import { formatInTimeZone } from "date-fns-tz"

export type TStateCode =
  | "MD"
  | "IL"
  | "NY"
  | "PA"
  | "OH"
  | "NJ"
  | "MA"
  | "DE"
  | "DC"

export type TStateVerification = Record<
  string,
  string | string[] | boolean | null | undefined
>

export type TVerificationForm = {
  verificationItem: Record<string, boolean>
  account_number?: string
}

// Converts the script object into a flat array of strings
export function serializeScript(
  script: TStateVerification | undefined,
): string[] {
  return Object.values(script ? script : {}).flatMap((value) => {
    if (value == null) return []
    if (typeof value == "boolean") return []
    return Array.isArray(value) ? value.filter(Boolean) : [value]
  })
}

export const getCurrentDateAndTimeEST = () => {
  const now = new Date()

  return {
    currentDate: formatInTimeZone(now, "America/New_York", "MM/dd/yyyy"),
    currentTime: formatInTimeZone(now, "America/New_York", "h:mm a"),
  }
}
